import { useCallback } from 'react';
import { validateField } from '../../../stream/transfer/control';
import useControlNext from '../../state/useControlNext';
/**
 * Provides validateField function
 *
 * @documented
 * @import import useValidateField from '@gef-ui/form-core/hooks/field/useValidateField'
 * @param {Object} input
 * @param {String} input.fieldName
 * @param {Number[]} [input.fieldIndices] - indices for array, can be nested and sorted by path of nesting
 * @param {boolean} [input.expandDependent=true] - validate dependent fields
 * @param {Object} [input.groups = all validations on all types]
 * @param {String[]} [input.groups.dirtyGroup] - validation types for given group
 * @param {String[]} [input.groups.pristineGroup] - validation types for given group
 * @param {String[]} [input.groups.notPresentGroup] - validation types for given group
 * @returns {Function} validateField
 * @example
 *
 * 	const validateField = useValidateField({fieldName: 'xxx'});
 *
 */ const useValidateField = ({ fieldName, fieldIndices, validationGroups, expandDependent })=>{
    const next = useControlNext();
    const validateFieldCb = useCallback(()=>{
        next(validateField({
            fieldName,
            fieldIndices,
            validationGroups,
            expandDependent
        }));
    }, [
        fieldName,
        fieldIndices,
        next,
        validationGroups,
        expandDependent
    ]);
    return validateFieldCb;
};
export default useValidateField;
